import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import {
  Add,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Minus,
} from '@factorialco/f0-react/icons/app'
import * as PIXI from 'pixi.js'

import i18n from 'modules/core/lib/i18n'

export const MapControls = ({ viewport }: { viewport: PIXI.Container | null }) => {
  const zoomFactor = 1.1
  const moveDelta = 50

  const zoomIn = () => {
    if (!viewport) return
    viewport.scale.x *= zoomFactor
    viewport.scale.y *= zoomFactor
  }

  const zoomOut = () => {
    if (!viewport) return
    viewport.scale.x /= zoomFactor
    viewport.scale.y /= zoomFactor
  }

  const move = (dx: number, dy: number) => {
    if (!viewport) return
    viewport.x += dx
    viewport.y += dy
  }

  return (
    <Box
      position="absolute"
      style={{
        right: '1rem',
        top: '1rem',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        pointerEvents: 'all',
      }}
      flexDirection="column"
      gap="s8"
      alignItems="center"
      background="grey100"
      padding="s8"
      borderRadius={{ all: 'abs008' }}
    >
      <Box flexDirection="row" gap="s8" alignItems="center">
        <F0Button
          onClick={zoomIn}
          icon={Add}
          size="sm"
          variant="outline"
          hideLabel
          label={i18n.t('space_control.map_controls.zoom_in')}
        />
        <F0Button
          onClick={zoomOut}
          icon={Minus}
          size="sm"
          variant="outline"
          hideLabel
          label={i18n.t('space_control.map_controls.zoom_out')}
        />
      </Box>
      <Box flexDirection="column" gap="s2" alignItems="center">
        <F0Button
          onClick={() => move(0, moveDelta)}
          icon={ArrowUp}
          variant="outline"
          size="sm"
          hideLabel
          label={i18n.t('space_control.map_controls.move_up')}
        />
        <Box flexDirection="row" gap="s2" alignItems="center">
          <F0Button
            onClick={() => move(moveDelta, 0)}
            icon={ArrowLeft}
            variant="outline"
            size="sm"
            hideLabel
            label={i18n.t('space_control.map_controls.move_left')}
          />
          <Box width="s4" height="s4" />
          <F0Button
            onClick={() => move(-moveDelta, 0)}
            icon={ArrowRight}
            variant="outline"
            size="sm"
            label={i18n.t('space_control.map_controls.move_right')}
            hideLabel
          />
        </Box>
        <F0Button
          onClick={() => move(0, -moveDelta)}
          icon={ArrowDown}
          variant="outline"
          size="sm"
          label={i18n.t('space_control.map_controls.move_down')}
          hideLabel
        />
      </Box>
    </Box>
  )
}
